<div class="section">
  <h3>
    {{ 'COMMON.SUMMARY' | translate }}
    <mat-icon class="copy-icon" (click)="copyToClipboard(summary())">content_copy</mat-icon>
  </h3>
  <p>{{ summary() }}</p>
</div>

<div class="section">
  <h3>
    {{ 'COMMON.KEY_TAKEAWAYS' | translate }}
    <mat-icon class="copy-icon" (click)="copyToClipboard(keyTakeaways())">content_copy</mat-icon>
  </h3>
  <ul>
    @for (takeaway of keyTakeaways(); track takeaway) {
      <li>{{ takeaway }}</li>
    }
  </ul>
</div>

<div class="section">
  <h3>
    {{ 'COMMON.ACTION_ITEMS' | translate }}
    <mat-icon class="copy-icon" (click)="copyToClipboard(actionItems())">content_copy</mat-icon>
  </h3>
  <ul>
    @for (item of actionItems(); track item) {
      <li>{{ item }}</li>
    }
  </ul>
</div>
